import { render, staticRenderFns } from "./CandidateDetail.vue?vue&type=template&id=06b160f0&scoped=true"
import script from "./CandidateDetail.vue?vue&type=script&lang=js"
export * from "./CandidateDetail.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetail.vue?vue&type=style&index=0&id=06b160f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b160f0",
  null
  
)

export default component.exports